import { useState } from 'react'
import classNames from 'classnames'
import { HIRAGANA_SETS, KATAKANA_SETS } from './kana'
import {
  AppUI,
  PageUI,
  TabsUI,
  TabUI,
  SetsContainerUI,
  KanaSetUI,
  ColumnUI,
  OptionsUI,
  ButtonUI,
} from './App.styles'

import KanaPractice from './KanaPractice'
import RomajiPractice from './RomajiPractice'

function App() {
  const [chosenSets, setChosenSets] = useState([])
  const [page, setPage] = useState('config')
  const [font, setFont] = useState('sans-serif')
  const [type, setType] = useState('kana')
  const [kana, setKana] = useState('hiragana')
  const [timed, setTimed] = useState(0)
  const [mode, setMode] = useState('oneGo')

  return (
    <AppUI className={classNames(`font-${font}`)}>
      <PageUI className={classNames('PageUI', `page-${page}`)}>
        {page === 'config' && (
          <>
            <h1>Choose the sets you want to study</h1>
            <TabsUI className="TabsUI">
              <TabUI
                className={classNames(
                  'hiragana-tab',
                  kana === 'hiragana' && 'is-active',
                  !!chosenSets.find((set) =>
                    Object.keys(HIRAGANA_SETS).includes(set)
                  ) && 'found'
                )}
                onClick={(e) => {
                  kana !== 'hiragana' && setKana('hiragana')
                }}
              >
                Hiragana
              </TabUI>
              <TabUI
                className={classNames(
                  'katakana-tab',
                  kana === 'katakana' && 'is-active',
                  !!chosenSets.find((set) =>
                    Object.keys(KATAKANA_SETS).includes(set)
                  ) && 'found'
                )}
                onClick={(e) => {
                  kana !== 'katakana' && setKana('katakana')
                }}
              >
                Katakana
              </TabUI>
            </TabsUI>
            <SetsContainerUI
              className={classNames(
                'SetsContainerUI',
                kana === 'katakana'
                  ? 'is-katakana-active-tab'
                  : 'is-hiragana-active-tab'
              )}
            >
              {kana === 'hiragana' &&
                Object.keys(HIRAGANA_SETS).map((set, index) => {
                  return (
                    <ColumnUI
                      className={classNames(
                        'ColumnUI',
                        chosenSets.includes(set) && 'is-checked',
                        `font-${font}`
                      )}
                      key={set}
                      htmlFor={`set-${set}`}
                    >
                      <input
                        type="checkbox"
                        name={`set-${set}`}
                        id={`set-${set}`}
                        checked={chosenSets.includes(set)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setChosenSets(chosenSets.concat(set).sort())
                          } else {
                            setChosenSets(
                              chosenSets.filter((chosen) => chosen !== set)
                            )
                          }
                        }}
                      />
                      <KanaSetUI className="HiraganaSetUI">
                        {HIRAGANA_SETS[set].map((chars) => (
                          <div key={chars[1]}>{chars[0]}</div>
                        ))}
                      </KanaSetUI>
                    </ColumnUI>
                  )
                })}
              {kana === 'katakana' &&
                Object.keys(KATAKANA_SETS).map((set, index) => {
                  return (
                    <ColumnUI
                      className={classNames(
                        'ColumnUI',
                        chosenSets.includes(set) && 'is-checked',
                        `font-${font}`
                      )}
                      key={set}
                      htmlFor={`set-${set}`}
                    >
                      <input
                        type="checkbox"
                        name={`set-${set}`}
                        id={`set-${set}`}
                        checked={chosenSets.includes(set)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setChosenSets(chosenSets.concat(set).sort())
                          } else {
                            setChosenSets(
                              chosenSets.filter((chosen) => chosen !== set)
                            )
                          }
                        }}
                      />
                      <KanaSetUI className="HiraganaSetUI">
                        {KATAKANA_SETS[set].map((chars) => (
                          <div key={chars[1]}>{chars[0]}</div>
                        ))}
                      </KanaSetUI>
                    </ColumnUI>
                  )
                })}
            </SetsContainerUI>
            <div className="select-actions">
              <ButtonUI
                className="all-hiragana"
                onClick={() =>
                  setChosenSets(chosenSets.concat(Object.keys(HIRAGANA_SETS)))
                }
              >
                All Hiragana
              </ButtonUI>
              <ButtonUI
                className="all-katakana"
                onClick={() =>
                  setChosenSets(chosenSets.concat(Object.keys(KATAKANA_SETS)))
                }
              >
                All Katakana
              </ButtonUI>

              {chosenSets.length > 0 && (
                <ButtonUI onClick={() => setChosenSets([])}>
                  Deselect all
                </ButtonUI>
              )}
            </div>
            <OptionsUI>
              <div>Font:</div>
              <label htmlFor="sans-serif">
                <input
                  type="radio"
                  name="font"
                  id="sans-serif"
                  checked={font === 'sans-serif'}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setFont('sans-serif')
                    }
                  }}
                />
                Sans Serif
              </label>
              <label htmlFor="serif">
                <input
                  type="radio"
                  name="font"
                  id="serif"
                  checked={font === 'serif'}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setFont('serif')
                    }
                  }}
                />
                Serif
              </label>
            </OptionsUI>
            <OptionsUI>
              <div>Practice type:</div>
              <label htmlFor="kana">
                <input
                  type="radio"
                  name="practice-type"
                  id="kana"
                  checked={type === 'kana'}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setType('kana')
                    }
                  }}
                />
                Kana
              </label>
              <label htmlFor="romaji">
                <input
                  type="radio"
                  name="practice-type"
                  id="romaji"
                  checked={type === 'romaji'}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setType('romaji')
                    }
                  }}
                />
                Romaji
              </label>
            </OptionsUI>
            <OptionsUI>
              <div>Practice mode:</div>
              <label htmlFor="oneGo">
                <input
                  type="radio"
                  name="practice-mode"
                  id="oneGo"
                  checked={mode === 'oneGo'}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setMode('oneGo')
                    }
                  }}
                />
                One Go
              </label>
              <label htmlFor="infinite">
                <input
                  type="radio"
                  name="practice-mode"
                  id="infinite"
                  checked={mode === 'infinite'}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setMode('infinite')
                    }
                  }}
                />
                Infinite
              </label>
            </OptionsUI>
            {type === 'romaji' && (
              <OptionsUI>
                <div>Timed mode:</div>
                <label htmlFor="off">
                  <input
                    type="radio"
                    name="timed"
                    id="off"
                    checked={timed === 0}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setTimed(0)
                      }
                    }}
                  />
                  No timer
                </label>
                <label htmlFor="secs-3">
                  <input
                    type="radio"
                    name="timed"
                    id="secs-3"
                    checked={timed === 3000}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setTimed(3000)
                      }
                    }}
                  />
                  3 seconds
                </label>
                <label htmlFor="secs-5">
                  <input
                    type="radio"
                    name="timed"
                    id="secs-5"
                    checked={timed === 5000}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setTimed(5000)
                      }
                    }}
                  />
                  5 seconds
                </label>
              </OptionsUI>
            )}
            {chosenSets.length > 0 && (
              <ButtonUI
                className="lets-practice"
                onClick={(e) => {
                  setPage(type)
                }}
              >
                Let's practice!
              </ButtonUI>
            )}
          </>
        )}
        {page === 'kana' && (
          <KanaPractice sets={chosenSets} setPage={setPage} mode={mode} />
        )}
        {page === 'romaji' && (
          <RomajiPractice
            sets={chosenSets}
            setPage={setPage}
            mode={mode}
            timed={timed}
          />
        )}
      </PageUI>
    </AppUI>
  )
}

export default App
